interface Props {
  date: Date | string | number;
  mask?: string;
  utc?: boolean;
  suffix?: string;
  className?;
}

const formatDate = (
  date: Date | string | number,
  mask = "dd/mmm/yyyy",
  utc = false
): string => {
  let dateObj: any;
  if (date instanceof Date) {
    dateObj = date;
  } else {
    dateObj = new Date(date);
  }

  const getUTC = (method: string) => `getUTC${method}` as keyof Date;
  const getLocal = (method: string) => `get${method}` as keyof Date;

  const getMethod = (method: string) =>
    utc ? getUTC(method) : getLocal(method);

  const day = dateObj[getMethod("Date")]().toString().padStart(2, "0");
  const month = (dateObj[getMethod("Month")]() + 1).toString().padStart(2, "0");
  const fullYear = dateObj[getMethod("FullYear")]().toString();
  const year = fullYear.slice(-2);

  const th = {
    "01": "st",
    "02": "nd",
    "03": "rd",
    "21": "st",
    "22": "nd",
    "23": "rd",
    "31": "st",
  };

  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const fullMonthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const shortMonth = monthNames[dateObj[getMethod("Month")]()];
  const fullMonth = fullMonthNames[dateObj[getMethod("Month")]()];

  const hour = dateObj[getMethod("Hours")]().toString().padStart(2, "0");
  const minutes = dateObj[getMethod("Minutes")]().toString().padStart(2, "0");
  const meridiem = dateObj[getMethod("Hours")]() >= 12 ? "PM" : "AM";

  return mask
    .replace("ddd", daysOfWeek[dateObj[getMethod("Day")]()])
    .replace("ddth", th[day] ? `${day}${th[day]}` : `${day}th`)
    .replace("dd", day)
    .replace("mmmm", fullMonth)
    .replace("mmm", shortMonth)
    .replace("mm", month)
    .replace("yyyy", fullYear)
    .replace("yy", year)
    .replace("hour", hour)
    .replace("min", minutes)
    .replace("aa", meridiem);
};

export const DateLabel = ({
  date,
  mask = "dd/mmm/yyyy",
  utc,
  suffix = "",
  className,
}: Props) => {
  return (
    <span className={className}>
      {formatDate(date, mask, utc)} {suffix}
    </span>
  );
};
